var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isSignedIn)?_c('v-btn',{attrs:{"outlined":"","rounded":""},on:{"click":_vm.login}},[_c('v-icon',[_vm._v(" mdi-account ")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }